export default "<button mat-stroked-button (click)=\"sendTransaction()\">\n    Call smart contract\n</button>"